import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Flag icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Flag } from '@sravni/design-system-icons'
 *
 * <Flag />
 * ```
 */
var Flag = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Flag", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.167 17.5V3.275M15.833 11.683v-8.35M4.167 11.667s.729-.606 2.916-.606c2.188 0 3.646 1.439 5.834 1.439 2.187 0 2.916-.814 2.916-.814M4.167 3.277S4.896 2.5 7.083 2.5c2.188 0 3.646 1.44 5.834 1.44 2.187 0 2.916-.607 2.916-.607", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Flag };
//# sourceMappingURL=Flag.js.map
